var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable } from 'mobx';
import { sortedSet } from '../../../../utils/mobx/decorators/customComputed';
export class HistoryAnswers {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get history() {
        return this.parent;
    }
    get app() {
        return this.history.app;
    }
    get answersFromDatabase() {
        return this.history.historyDbMicroAnswers.microAnswersBeforePageLoad.map(microAnswer => this.app.tray.trayTransform.microAnswerToAnswer(microAnswer));
    }
    get answersFinishedSincePageLoad() {
        return this.history.historyRecentAnswers.answersFinishedSincePageLoad.filter(answer => !!answer.finishDate);
    }
    get answersFinished() {
        return [...this.answersFromDatabase, ...this.answersFinishedSincePageLoad];
    }
}
__decorate([
    sortedSet
], HistoryAnswers.prototype, "answersFromDatabase", null);
__decorate([
    sortedSet
], HistoryAnswers.prototype, "answersFinishedSincePageLoad", null);
